<template>
  <div class="app-container">
    <list ref="list">
      <template slot="toolbar-right">
        <el-button size="mini" type="success" @click="toLs" v-if="$permission.can('读','/attendance/qualification')">留宿资格</el-button>
        <el-button size="mini" class="filter-item" type="primary" v-if="$permission.canWrite()" @click="handle">处理</el-button>
      </template>
      <template slot="column" v-if="$permission.canWrite()">
        <el-table-column label="操作" fixed="right" align="center" width="85">
          <template slot-scope="{row}">
            <el-button type="text" @click="handleRecord(row)">处理记录</el-button>
          </template>
        </el-table-column>
      </template>
    </list>
    <edit-dialog ref="editDialog" @close-saved="toReload"></edit-dialog>
    <record-dialog ref="recordDialog" @close-saved="toReload"></record-dialog>
  </div>
</template>
<script>
import curdMixins from "@/mixins/curd";
import list from "@/components/st/wj/list";
import editDialog from "@/components/st/wj/editDialog";
import recordDialog from "@/components/st/wj/recordDialog";

export default {
  name: "wj",
  mixins: [curdMixins],
  components: {
    list,
    editDialog,
    recordDialog,
  },
  data() {
    return {
      isMB: this.$store.state.isMB,
    }
  },
  methods: {
    reload() {},
    toLs() {
      this.$router.push({ path: "/attendance/qualification" })
    },
    toReload() {
      this.$refs.list.query();
    },
    handleRecord(row) {
      this.$refs.recordDialog.openCreate(row);
    },
    handle() {
      let rows = this.$refs.list.getCheckedRows();
      if (rows.length == 0) {
        this.$message.warning("请选择要处理的数据");
        return;
      }
      let ids = rows.map((item) => {
        return item.StudentId;
      });
      this.$refs.editDialog.openCreate({ ids })
    },
  },
};
</script>